// ============================================================
// FILE: resources/js/helpers/utils.js
// USPATIH GO — Utility Helpers (Debounce, Clipboard)
// ============================================================

/**
 * Debounce function
 * @param {Function} fn
 * @param {number} delay
 * @returns {Function}
 */
export function debounce(fn, delay = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}

/**
 * Copy text to clipboard
 * @param {string} text
 * @returns {Promise<boolean>}
 */
export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    window.toast('Disalin ke clipboard!', 'success');
    return true;
  } catch {
    return false;
  }
}

// ---- Expose ke window ----------------------------------------
window.debounce         = debounce;
window.copyToClipboard  = copyToClipboard;
